module.exports = __webpack_public_path__ + "ab38722c7ffb410fb0b263fdb393b483.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/gorgutz-panel-1024.webp.png
// module id = 371
// module chunks = 0